import * as React from 'react';
import Grid from "@mui/material/Grid";
import ActionLogsIndex from "./ActionLogsIndex";
import {useState} from "react";
import {useSearchParams} from "react-router-dom";
import {Stack} from "@mui/material";
import {Refresh} from "@mui/icons-material";
import Button from "@mui/material/Button";
import ActionLogsFilter from "./ActionLogsFilter";
import IconButton from "@mui/material/IconButton";
import helpers from '../../helpers/common';
import PageHeader from '../layout/PageHeader';
import SectionCard from '../layout/SectionCard';
import FilterPanel from '../layout/FilterPanel';

export default function ActionLogsContainer() {
    const [searchParams, setSearchParams] = useSearchParams()
    const [refreshId, setRefreshId] = useState(0)
    const accordionExpanded = Array.from(searchParams).length > 0

    const refresh = () => {
        setRefreshId((prevId) => {
            return prevId + 1
        })
    }

    return <React.Fragment>
        <Grid size={12}>
            <PageHeader
                title="Логи действий"
                breadcrumbs={[['Dashboard', '/'], ['Логи действий', '/action-logs']]}
                actions={
                    <>
                        <Button onClick={refresh} variant="contained" startIcon={<Refresh />}>
                            Обновить
                        </Button>
                    </>
                }
            />
        </Grid>
        <Grid size={12}>
            <FilterPanel
                defaultExpanded={accordionExpanded}
                title="Фильтры"
                sx={{ '& .MuiAccordionSummary-root': { py: 0.5 } }}
            >
                <ActionLogsFilter />
            </FilterPanel>
        </Grid>
        <Grid size={12}>
            <Stack spacing={1.5} direction="row" sx={{display: {xs: 'inherit', md: 'none'}}}>
                <IconButton onClick={refresh} color="primary"><Refresh /></IconButton>
            </Stack>
        </Grid>
        <Grid size={12}>
            <SectionCard sx={{ display: 'flex', flexDirection: 'column', overflowX: 'auto'}}>
                <ActionLogsIndex fullPage={true} searchParams={searchParams} setSearchParams={setSearchParams} refreshId={refreshId}/>
            </SectionCard>
        </Grid>
    </React.Fragment>
}






